import Hammer from 'hammerjs';
class ToolbarManager {

    private _parentContainer: HTMLDivElement;
    private _containers: { [id: string]: IToolbarContainer } = {};
    
    private _sections: { [n: string]: { [n: string]: ToolbarSection; }; } = { };
    constructor(div: HTMLDivElement) {
        this.addSection = this.addSection.bind(this);
        this.dipose = this.dipose.bind(this);
        this.toggleToolbar = this.toggleToolbar.bind(this);
        this.findSectionById = this.findSectionById.bind(this);

        this._parentContainer = div;
    }

    public addToolbar(id: string, group: string) {
        if (!this._containers[id]) {
            var toolbarContainer = document.createElement("div");
            toolbarContainer.className = 'vt-container';
            toolbarContainer.style.marginRight = '5px';
            toolbarContainer.style.marginLeft = "5px";

            this._parentContainer.appendChild(toolbarContainer);

            this._containers[id] = { DivElement: toolbarContainer as HTMLDivElement, Group: group, GroupEnabled : true };
            this._sections[id] = {};
        }
    }

    public addSection(toolbarId: string, id: string) {
        //What to do when duplicate ids on section
        var section = this.findSectionById(toolbarId, id);
        if (section) {
            return section;
        }

        section = new ToolbarSection(id, this._containers[toolbarId].DivElement);

        this._sections[toolbarId][id] = section;

        return section;
    }

    public findSectionById(toolbarId : string, id: string) {
        return this._sections[toolbarId][id];
    }
    
    public toggleToolbar(toolbarId: string, show: boolean) {

        if (show && this._containers[toolbarId].GroupEnabled) {
            this._containers[toolbarId].DivElement.style.display = '';
        } else {
            this._containers[toolbarId].DivElement.style.display = 'none';
        }
    }

    public enableToolbar(toolbarId: string, enabled: boolean) {
        if (!enabled)
            this.toggleToolbar(toolbarId, false);

        this._containers[toolbarId].GroupEnabled = enabled;
    }

    public toggleToolbarGroup(group: string, show: boolean) {
        for (let toolbarId in this._containers) {
            let container = this._containers[toolbarId];
            if (container.Group == group && container.GroupEnabled) {
                if (show) {
                    container.DivElement.style.display = '';
                } else {
                    container.DivElement.style.display = 'none';
                }
            }
        }
    }

    public dipose() {
        for (var k in this._sections) {

            for (var x in this._sections[k]) {

                this._sections[k][x].dispose();
            }

            if (this._containers[k] && this._containers[k].DivElement.remove) {
                this._containers[k].DivElement.remove();
            }
            else if (this._containers[k]) {
                this._parentContainer.removeChild(this._containers[k].DivElement);
            }
        }
    }
}

interface IToolbarContainer {
    DivElement: HTMLDivElement;
    Group: string;
    GroupEnabled: boolean;
};

class ToolbarSection {
    private _id: string;
    private _parent: HTMLDivElement;
    private _thisContainer: HTMLDivElement;
    private _commands: { [id: string]: ToolCommand } = {};
    private _groups: { [id: string]: ToolCommandGroup } = {};
    private _sets: { [id: string]: ToolCommand } = {};
    constructor(id: string, parent: HTMLDivElement) {
        this._bindFunctions();

        this._id = id;
        this._parent = parent;
        this._thisContainer = document.createElement('div');
        this._thisContainer.className = 'vt-section';

        this._parent.appendChild(this._thisContainer);
    }

    private _bindFunctions() {
        this._handleSets = this._handleSets.bind(this);
        this._createCommand = this._createCommand.bind(this);

        this.dispose = this.dispose.bind(this);
        this.addCommand = this.addCommand.bind(this);
        this.findCommandById = this.findCommandById.bind(this);
        this.setSelected = this.setSelected.bind(this);
        this.setGroupTooltip = this.setGroupTooltip.bind(this);
        this.addGroupCommand = this.addGroupCommand.bind(this);
        this.addGroup = this.addGroup.bind(this);
    }

    private _handleSets(id: string, setId: string, cb: (e: any) => void) {
        var that = this;
        return function (e: any) {
            var cmd = that._commands[id];
            that._sets[setId].setSelected(false);
            that._sets[setId] = cmd;
            cmd.setSelected(true);
            cb(e);
        };
    }

    private _createCommand(id: string, imgUrl: string, cb: (e: any) => void, type: ToolbarManager.CommandType) {
        
        var toolCommand = new ToolCommand(id, this._thisContainer, cb, type);

        toolCommand.setImage(imgUrl);

        return toolCommand;
    }

    public addCommand(id: string, imgUrl: string, cb: (e: any) => void, type: ToolbarManager.CommandType, setId?: string) {
        //What to do with duplicate IDs on commands...
        var callback = setId ? this._handleSets(id, setId, cb) : cb;

        var toolCommand = this._createCommand(id, imgUrl, callback, type);

        this._commands[id] = toolCommand;

        return toolCommand;
    }

    public addGroup(id: string, imgUrl: string, cb: (e: any) => void) {
        var toolGroup = new ToolCommandGroup(id, this._thisContainer, cb);

        toolGroup.setImage(imgUrl);

        this._groups[id] = toolGroup;
    }

    public addGroupCommand(groupId: string, id: string, imgUrl: string, cb: (e: any) => void, type: ToolbarManager.CommandType, setId?: string) {
        var callback = setId ? this._handleSets(id, setId, cb) : cb;

        var toolGroup = this._groups[groupId];
        var toolCommand = toolGroup.addCommand(id, imgUrl, callback, type);

        return toolCommand;
    }

    public setGroupTooltip(groupId: string, text: string) {
        var toolGroup = this._groups[groupId];
        toolGroup.setTooltip(text);
    }

    public setSelected(id: string, setId: string) {
        var cmd = this._commands[id];
        this._sets[setId] = cmd;
        cmd.setSelected(true);
    }

    public findCommandById(id: string) {
        return this._commands[id];
    }

    public dispose() {
        for (var k in this._commands) {
            this._commands[k].dispose();
        }
        for (var k in this._groups) {
            this._groups[k].dispose();
        }
        if (this._thisContainer.remove) {
            this._thisContainer.remove();
        } else {
            if (this._parent) {
                this._parent.removeChild(this._thisContainer);
            }
        }
    }
}

class ToolCommandGroup {
    private _id: string;
    private _parent: HTMLDivElement;
    private _thisContainer: HTMLDivElement;
    private _commandsContainer: HTMLDivElement;
    private _thisMenuContainer: HTMLDivElement;
    private _thisItem: ToolCommand;
    private _commands: { [id: string]: ToolCommand } = {};
    private _toggle: boolean;
    private _callback: (e: any) => void;
    private _hammerManager: any;

    constructor(id: string, parent: HTMLDivElement, cb: (e: any) => void) {
        this._bindFunctions();

        this._id = id;
        this._parent = parent;
        this._callback = cb;
        this._thisContainer = document.createElement('div');

        this._thisContainer.className = 'vt-group';

        this._thisMenuContainer = document.createElement('div');
        this._thisMenuContainer.className = 'vt-menu-arrow';
        
        this._commandsContainer = document.createElement('div');
        this._commandsContainer.className = 'vt-group-ctn';
        this._toggle = false;

        this._thisContainer.appendChild(this._thisMenuContainer);
        this._thisItem = new ToolCommand(id + '_main', this._thisContainer, cb, ToolbarManager.CommandType.Command);

        this._hammerManager = new Hammer.Manager(this._thisItem.getContainer(), {inputClass: Hammer.TouchInput});
        this._hammerManager.add(new Hammer.Press({
            event: 'press',
            pointers: 1,
            time: 500
        }));

        this._hammerManager.on('pressup', this._onMenuPressUp);
        this._hammerManager.on('press', this._onMenuClick);
        this._thisItem.getContainer().oncontextmenu = function () { return false; };

        this._thisContainer.appendChild(this._commandsContainer);
        this._parent.appendChild(this._thisContainer);

        this._addEventListeners();
    }

    private _bindFunctions() {
        this._onMenuClick = this._onMenuClick.bind(this);
        this._closeMenu = this._closeMenu.bind(this);
        this._addEventListeners = this._addEventListeners.bind(this);
        this._removeEventListeners = this._removeEventListeners.bind(this);
        this._onMenuPressUp = this._onMenuPressUp.bind(this);

        this.dispose = this.dispose.bind(this);
        this.setImage = this.setImage.bind(this);
        this.addCommand = this.addCommand.bind(this);
        this.setTooltip = this.setTooltip.bind(this);
        this.addClass = this.addClass.bind(this);
        this.removeClass = this.removeClass.bind(this);
    }
    
    private _onMenuPressUp(e: any) {
        var that = this;
        // There is a click event after the press up, this is a workaround to not trigger 
        // the group item click and to not trigger the menu click after press up.
        setTimeout(function () { that._thisItem.setEnabled(true); }, 250);
        if (this._toggle) {
            window.removeEventListener('click', this._closeMenu);
            setTimeout(function () { window.addEventListener('click', that._closeMenu); }, 200);
        } else {
            window.addEventListener('click', this._closeMenu);
            setTimeout(function () { window.removeEventListener('click', that._closeMenu); }, 200);
        }
    }

    private _onMenuClick(e: MouseEvent | any) {
        // Set enabled on the item and setTimeout are a workaround with hammerjs's press event.  at the end of the press event,
        // an click is triggered.  The optimal solution is to not trigger the event.  This was the alternative solution.
        this._thisItem.setEnabled(false);

        var that = this;
        if (this._toggle) {
            this._commandsContainer.className = this._commandsContainer.className.replace(' selected', '');
            setTimeout(function () {
                window.removeEventListener('click', that._closeMenu);
                that._thisItem.setEnabled(true);
            }, 200);
        } else {
            this._commandsContainer.className += ' selected';
            setTimeout(function () {
                window.addEventListener('click', that._closeMenu);
                that._thisItem.setEnabled(true);
            }, 200);
        }
        this._toggle = !this._toggle;

        e.preventDefault();
        
        if (e.stopPropagation) {
            e.stopPropagation();
        } else if (e.srcEvent as MouseEvent) {
            e.srcEvent.stopPropagation();
        }
    }

    private _closeMenu(e: MouseEvent) {
        this._commandsContainer.className = this._commandsContainer.className.replace(' selected', '');
        window.removeEventListener('click', this._closeMenu);
        this._toggle = false;
    }

    private _addEventListeners() {
        //this._thisItem.addEventListener('click', this._callback);
        this._thisMenuContainer.addEventListener('click', this._onMenuClick);
    }

    private _removeEventListeners() {
        //this._thisItem.removeEventListener('click', this._callback);
        this._thisMenuContainer.removeEventListener('click', this._onMenuClick);
    }

    public addCommand(id: string, imgUrl: string, cb: (e: any) => void, type: ToolbarManager.CommandType) {
        //What to do with duplicate IDs on commands...
        var that = this;
        var toolCommand = new ToolCommand(id, this._commandsContainer, function (e: any) {
            that._onMenuClick(e);
            cb(e);
        }, type);

        toolCommand.setImage(imgUrl);

        this._commands[id] = toolCommand;

        return toolCommand;
    }

    public setImage(imgUrl: string) {
        this._thisItem.setImage(imgUrl);
    }

    public setTooltip(text: string) {
        this._thisItem.setTooltip(text);
    }

    public addClass(className: string) {
        //Temp solution... much much much better way to handle this
        this._thisContainer.className += ' ' + className;
    }

    public removeClass(className: string) {

    }

    public dispose() {
        for (var k in this._commands) {
            this._commands[k].dispose();
        }
        this._removeEventListeners();
        if (this._thisContainer.remove) {
            this._thisContainer.remove();
        } else {
            if (this._parent) {
                this._parent.removeChild(this._thisContainer);
            }
        }
        this._hammerManager.destroy();
    }
}

class ToolCommand {
    private _id: string;
    private _parent: HTMLDivElement;
    private _thisContainer: HTMLDivElement;
    private _thisItem: HTMLImageElement;
    private _text: HTMLSpanElement;
    private _callback: any[];
    private _type: ToolbarManager.CommandType;
    private _selected: boolean;
    private _enabled: boolean;

    constructor(id: string, parent: HTMLDivElement, cb: any, type: ToolbarManager.CommandType) {
        this._bindFunctions();

        this._id = id;
        this._callback = [cb];
        this._parent = parent;
        this._type = type;
        this._selected = false;
        this._thisContainer = document.createElement('div');
        this._thisContainer.className = 'vt-item';
        this._enabled = true;

        switch (type) {
            case ToolbarManager.CommandType.Mode: this._thisContainer.className += ' vt-item-toggle'; break;
            case ToolbarManager.CommandType.Toggle: this._thisContainer.className += ' vt-item-toggle'; break;
            case ToolbarManager.CommandType.Command: this._thisContainer.className += ' vt-item-cmd'; break;
            default: this._thisContainer.className = 'vt-item';
        }

        this._thisContainer.id = "toolbar." + id;
        this._thisItem = document.createElement('img');
        this._addEventListeners();
        this._text = document.createElement('span');
        this._text.style.display = 'none';

        var contentContainer = document.createElement('div');
        contentContainer.className = 'vt-item-ctn';

        contentContainer.appendChild(this._thisItem);
        contentContainer.appendChild(this._text);

        this._thisContainer.appendChild(contentContainer);

        this._parent.appendChild(this._thisContainer);
    }

    private _bindFunctions() {
        this._addEventListeners = this._addEventListeners.bind(this);
        this._removeEventListeners = this._removeEventListeners.bind(this);
        this._onClick = this._onClick.bind(this);

        this.dispose = this.dispose.bind(this);
        this.setImage = this.setImage.bind(this);
        this.setSelected = this.setSelected.bind(this);
        this.getContainer = this.getContainer.bind(this);
        this.addClass = this.addClass.bind(this);
        this.removeClass = this.removeClass.bind(this);
        this.setEnabled = this.setEnabled.bind(this);
        this.setText = this.setText.bind(this);
        this.setTooltip = this.setTooltip.bind(this);
        this.getSelected = this.getSelected.bind(this);
        this.getEnabled = this.getEnabled.bind(this);
        this.addCallback = this.addCallback.bind(this);
        this.removeCallback = this.removeCallback.bind(this);
    }

    private _addEventListeners() {
        this._thisContainer.addEventListener('click', this._onClick);
    }

    private _removeEventListeners() {
        this._thisContainer.removeEventListener('click', this._onClick);
    }

    private _onClick(e: any) {
        if (this._enabled) {
            if (this._type === ToolbarManager.CommandType.Mode) {
                this.setSelected(true);
            }
            else if (this._type === ToolbarManager.CommandType.Toggle) {
                this.setSelected(!this.getSelected());
            }
            if (this._callback.length > 0) {
                this._callback[0](e);
                for (var i = 1; i < this._callback.length; i++) {
                    this._callback[i]();
                }
            }
        }
    }

    public addCallback(callback: any) {
        this._callback.push(callback);
    }

    public removeCallback(callback: any) {
        for (var k = 0; k < this._callback.length; k++) {
            if (this._callback[k].toString() == callback.toString()) {
                this._callback.splice(k, 1);
            }
        }
    }

    public setImage(imgUrl: string) {
        this._thisItem.src = imgUrl;
        return this;
    }

    public addClass(className: string) {
        //Temp solution... much much much better way to handle this
        this._thisContainer.className += ' ' + className;
    }

    public setSelected(selected: boolean) {
        this._selected = selected;
        this._thisContainer.className = this._thisContainer.className.replace(' selected', '');
        if (selected) {
            this._thisContainer.className += ' selected';
        }
    }

    public getSelected() {
        return this._selected;
    }

    public setEnabled(enabled: boolean) {
        this._enabled = enabled;
    }

    public getEnabled() {
        return this._enabled;
    }

    public getContainer() {
        return this._thisContainer;
    }

    public removeClass(className: string) {
        this._thisContainer.className = (' ' + this._thisContainer.className).replace(' ' + className, '').trim();
    }

    public setText(text: string, setTooltip?: boolean) {
        this._text.innerHTML = text;
        this._text.style.display = '';

        if (setTooltip) {
            this.setTooltip(text);
        }

        return this;
    }

    public setTooltip(text: string) {
        this._thisContainer.title = text;
        return this;
    }

    public dispose() {
        this._removeEventListeners();
        if (this._thisContainer.remove) {
            this._thisContainer.remove();
        } else {
            if (this._parent) {
                this._parent.removeChild(this._thisContainer);
            }
        }
    }
}

module ToolbarManager {
    export enum CommandType {
        Mode, Toggle, Command
    }
}

export default ToolbarManager;